import React from 'react';
import { UserOutlined, RobotOutlined } from '@ant-design/icons';
import { Avatar as AntAvatar } from 'antd';
import { useSelector } from 'react-redux';
import { IAppState } from 'src/interface/IAppState';
import { IChatMessage } from 'src/interface/IChatState';
import { MarkdownContent } from 'src/styled/Chat/Markdown.styled';
import {
  BubbleContainer,
  AvatarWrapper,
  BubbleContent,
  Bubble,
  Timestamp
} from 'src/styled/Chat/MessageBubble.styled';
import { parseMarkdown } from 'src/utils/markdown-renderer';

interface IMessageBubbleProps {
  message: IChatMessage;
}

export const MessageBubble: React.FC<IMessageBubbleProps> = ({ message }) => {
  const isUser = message.sender_type === 'user';
  const userProfile = useSelector((state: IAppState) => state.headerState?.data);

  // Get favicon URL from document
  const getFaviconUrl = () => {
    if (typeof window === 'undefined') return '/favicon.ico';
    const favicon = document.querySelector<HTMLLinkElement>('link[rel*="icon"]');
    return favicon?.href || '/favicon.ico';
  };

  const formatTime = (timestamp: string) => {
    const date = new Date(timestamp);
    return date.toLocaleTimeString('vi-VN', {
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  // Parse markdown for bot messages only
  const displayContent = !isUser ? parseMarkdown(message.content || '') : message.content;

  return (
    <BubbleContainer isUser={isUser}>
      {!isUser && (
        <AvatarWrapper className="bot-avatar">
          <AntAvatar
            src={getFaviconUrl()}
            icon={<RobotOutlined />}
            size={32}
            style={{
              background: '#ffffff',
              color: '#1F2D3A'
            }}
          />
        </AvatarWrapper>
      )}
      <BubbleContent isUser={isUser}>
        <Bubble isUser={isUser}>
          {!isUser ? (
            <MarkdownContent dangerouslySetInnerHTML={{ __html: displayContent }} />
          ) : (
            message.content
          )}
        </Bubble>
        <Timestamp>{formatTime(message.created_at)}</Timestamp>
      </BubbleContent>
      {isUser && (
        <AvatarWrapper>
          <AntAvatar
            src={userProfile?.avatar_url}
            icon={<UserOutlined />}
            size={32}
            style={{
              background: '#ffffff',
              color: '#1F2D3A'
            }}>
            {!userProfile?.avatar_url && userProfile?.name
              ? userProfile.name[0].toUpperCase()
              : null}
          </AntAvatar>
        </AvatarWrapper>
      )}
    </BubbleContainer>
  );
};

export default MessageBubble;
